import { match } from 'ts-pattern';
import { TopColorCeramic as V5TopColorCeramic } from '../__generated/model/versions/v5.js';
import { TopColorCeramic as V6TopColorCeramic } from '../__generated/model/versions/v6.js';
export const migrateToV6 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().with({
            type: 'TopCircle'
        }, {
            type: 'TopDanishOval'
        }, {
            type: 'TopHalfCircle'
        }, {
            type: 'TopHalfOval'
        }, {
            type: 'TopOval'
        }, {
            type: 'TopRectangle'
        }, (entity)=>{
            const { color, ...rest } = entity;
            if (entity.color === V5TopColorCeramic.CarraraNaturel) {
                return {
                    ...rest,
                    color: V6TopColorCeramic.ClassicCarrara
                };
            }
            if (entity.color === V5TopColorCeramic.NegroAbsoluto) {
                return {
                    ...rest,
                    color: V6TopColorCeramic.DarkBlack
                };
            }
            if (entity.color === V5TopColorCeramic.BasicNegroNaturel) {
                return {
                    ...rest,
                    color: V6TopColorCeramic.DarkBlack
                };
            }
            if (entity.color === V5TopColorCeramic.TitanAntracita) {
                return {
                    ...rest,
                    color: V6TopColorCeramic.TitanCemento
                };
            }
            if (entity.color === V5TopColorCeramic.LavaIron) {
                return {
                    ...rest,
                    color: V6TopColorCeramic.LavaCorten
                };
            }
            if (entity.color === V5TopColorCeramic.BasicBlanco) {
                return {
                    ...rest,
                    color: V6TopColorCeramic.BasicNieve
                };
            }
            return {
                ...rest,
                color: entity.color
            };
        }).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v6.js.map